import {AppState} from '../reducer';
import {FLIP_CARD_SIDE} from '../../incase-domain/elements/flipCard';

export const getFlipCardSide = (state: AppState, elementId: string): FLIP_CARD_SIDE => {
    return state.flipCardReducer[elementId] || FLIP_CARD_SIDE.FRONT;
};
